import React, { useContext } from 'react';
import FavoriteContext from '../context/FavoriteContext';

const PokemonCard = ({ pokemon }) => {
  const { favoritePokemons, updateFavoritePokemons } = useContext(
    FavoriteContext
  );

  const blackHeart = '🖤';
  const redHeart = '❤';

  const heart = favoritePokemons.includes(pokemon.name) ? redHeart : blackHeart;

  const clickHeart = (e) => {
    e.preventDefault();
    updateFavoritePokemons(pokemon.name);
  };

  let styleType = pokemon.types[0].type.name;

  return (
    <div
      className={`card pokemon-card ${styleType} pl-3 pr-3 m-3`}
      style={{ width: '18rem' }}
    >
      <div className='card-body'>
        <div className='row justify-content-between pb-3'>
          <div className='col-xs-6 d-flex align-items-center'>
            <h5 className=''>{pokemon.name}</h5>
            <h6 className='ml-2 mt-1'>#{pokemon.id}</h6>
          </div>
          <div className='col-xs-6'>
            <button className='btn' onClick={clickHeart}>
              {heart}
            </button>
          </div>
        </div>
        <div className='row pb-3'>
          <div className='col-12'>
            <img
              src={pokemon.sprites.other.dream_world.front_default}
              className='card-img'
              alt={pokemon.name}
            />
          </div>
        </div>
        <div className='row'>
          <div className='col-6'>
            <h4>Type</h4>
            <div className='row d-flex flex-column justify-content-center pr-2'>
              {pokemon.types.map((type, id) => {
                return (
                  <h6 className='pokemon-type' key={`type id:${id}`}>
                    <i class='fas fa-circle'></i> {type.type.name}
                  </h6>
                );
              })}
            </div>
          </div>

          <div className='col-6'>
            <h4>Abilities</h4>
            <div className='row d-flex flex-column justify-content-center pl-2'>
              {pokemon.abilities.map((ability, id) => {
                return (
                  <h6 key={`ability id:${id}`} className='pokemon-type'>
                    <i className='fas fa-check'></i> {ability.ability.name}
                  </h6>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PokemonCard;
